import $ from 'jquery';

const navToggle = () => {
  $( '.nav' ).toggleClass( 'open' )
  $( 'body' ).toggleClass( 'no-scroll' )

  if ( !$( '.nav' ).hasClass( 'open' ) ) {
    $( '.menu-item.has-children' ).removeClass( 'is-open' )
    $( '.submenu-toggle, .parent-link' ).attr( 'aria-expanded', 'false' )
  }
}

$( window ).on( 'load', () => {
  $( '.nav' ).addClass( 'active' )
  $( '.nav-handle' ).on( 'click', () => {
    navToggle()
  } )

  $( '.submenu-toggle' ).on( 'click', ( event ) => {
    event.preventDefault()
    event.stopPropagation()

    const $item = $( event.currentTarget ).closest( '.menu-item' )
    const isOpen = $item.hasClass( 'is-open' )

    $( '.menu-item.has-children' ).not( $item ).removeClass( 'is-open' )
      .find( '.submenu-toggle, .parent-link' ).attr( 'aria-expanded', 'false' )

    $item.toggleClass( 'is-open', !isOpen )
    $item.find( '.submenu-toggle, .parent-link' ).attr( 'aria-expanded', String( !isOpen ) )
  } )

  $( '.main-menu .submenu-link' ).on( 'click', () => {
    if ( $( '.nav' ).hasClass( 'open' ) ) {
      navToggle()
    }
  } )
});

$( window ).on( 'resize', () => {
  if( $( '.nav' ).hasClass( 'open' ) ) {
    navToggle()
  }
});
